<template lang="html">

<div class="container">

    <header class="single-header" :style="{ background: project.background }">
        <img :src="project.logo" :alt="project.title">
    </header>

    <div class="single-content">

        <h1>{{ project.title }}<br>
            <small>{{ project.subtitle }}</small>
        </h1>

<!-- META CHIPS -->
        <div class="single-meta">

            <div class="single-meta__chip">

                <span class="single-meta__title" :style="{ background: project.color }">
                    Role
                </span>
                <span class="single-meta__content">{{ project.role }}</span>

            </div>

            <div class="single-meta__chip">

                <span class="single-meta__title":style="{ background: project.color }">
                    Features
                </span>
                <span class="single-meta__content">{{ project.features }}</span>

            </div>

        </div>

<!-- //// DESCRIPTION -->

        <div class="single-description">

            <slot></slot>

            <a class="btn"
                v-if="project.url"
                :style="{ background: project.color }"
                :href="project.url"
                target="_blank"
            >
                Visit Site
            </a>

        </div>

    </div>

</div>

</template>

<script>
import { EventBus } from '@/main'
export default {
    props: {
        project: {
            background: {
                type: String,
                required: true
            },
            color: {
                type: String,
                default: '#3d3d3d'
            },
            logo: {
                type: String
            },
            title: {
                type: String,
                required: true
            },
            subtitle: {
                type: String,
                required: true
            },
            role: {
                type: String,
                required: true
            },
            features: {
                type: String,
                required: true
            },
            url: {
                type: String
            }
        }
    },


    mounted() {
        EventBus.$emit('changeColor', this.project.color)
    }

}
</script>



// WEBPACK FOOTER //
// single-header.vue?09fa7c40